<template>
    <Head>
        <title>{{ page.title }}</title>
        <meta name="description" :content="page.extras.meta_description" />
        <meta name="keywords" :content="page.extras.meta_keywords" />
    </Head>

    <div class="container mx-auto">
        <div class="mx-auto mt-12 flex max-w-[1034px] p-4 pb-8">
            <frontend-header-h1
                :text="title"
                css-classes="handwritten-underline-lg"
            ></frontend-header-h1>
        </div>

        <div class="container mx-auto max-w-[1034px]">
            <div class="float-right ml-8 hidden md:block">
                <div class="mb-8">
                    <emtprep-upsell-ad />
                </div>
                <div class="mb-8">
                    <emtce-promo-ad />
                </div>
            </div>
            <div
                class="cms-wysiwyg-content order-1 flex-grow md:order-2"
                v-html="page.content"
            ></div>
            <div class="md:hidden">
                <div class="mb-8">
                    <emtprep-upsell-ad />
                </div>
                <div class="mb-8">
                    <emtce-promo-ad />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout";
import EmtprepUpsellAd from "@/Components/EmtprepUpsellAd";
import EmtcePromoAd from "@/Components/EmtcePromoAd";

export default {
    name: "CmsTemplateBasic",
    components: { EmtcePromoAd, EmtprepUpsellAd },
    layout: FrontendLayout,
    props: {
        title: {
            type: String,
            default: "Title",
        },
        page: {
            type: Object,
            default: {},
        },
    },
};
</script>
